import { render, staticRenderFns } from "./suggesTion.vue?vue&type=template&id=ab734672&scoped=true&"
import script from "./suggesTion.vue?vue&type=script&lang=js&"
export * from "./suggesTion.vue?vue&type=script&lang=js&"
import style0 from "./suggesTion.vue?vue&type=style&index=0&id=ab734672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab734672",
  null
  
)

export default component.exports